webpackJsonp([68],{

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1);
__webpack_require__(90);

// JavaScript
var $ = __webpack_require__(0);
__webpack_require__(2);

var isIE = false;
if (window.navigator.userAgent.indexOf("MSIE ") > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
    isIE = true;
}

$('.m-image__slider').each(function () {
    var $module = $(this);
    if ($('html').attr('lang') == 'fr') {
        $module.slick({
            infinite: true,
            useTransform: isIE ? false : true,
            cssEase: 'cubic-bezier(.38,.92,.75,1)',
            prevArrow: '<button type="button" class="m-image__slider-btn m-image__slider-btn--prev">Précédent</button>',
            nextArrow: '<button type="button" class="m-image__slider-btn m-image__slider-btn--next">Suivant</button>'
        });
    } else {
        $module.slick({
            infinite: true,
            useTransform: isIE ? false : true,
            cssEase: 'cubic-bezier(.38,.92,.75,1)',
            prevArrow: '<button type="button" class="m-image__slider-btn m-image__slider-btn--prev">Previous</button>',
            nextArrow: '<button type="button" class="m-image__slider-btn m-image__slider-btn--next">Next</button>'
        });
    }
});

/***/ }),

/***/ 90:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[89]);


// WEBPACK FOOTER //
// m-image.js